import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/slc-thriller-2022/ads/minky.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'Minky Couture Blankets',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/wvcarts.png',
      link: 'http://www.wvcarts.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'West Valley City Arts',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/challenger.png',
      link: 'http://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'Challenger Schools',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/country-hill-eye-center.png',
      link: 'http://www.checdocs.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'Country Hills Eye Center',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/hamilton_Park.png',
      link: 'http://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/jbr-clinic.png',
      link: 'http://www.jbrclinicalresearch.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'JBR Clinical Research',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/rubys-inn.png',
      link: 'http://www.rubysinn.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'Rubys inn',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/UFirstCU.png',
      link: 'http://www.ucreditu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
    {
      image: '/slc-thriller-2022/ads/ufo.png',
      link: 'http://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=odysseydancetheatre',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
